module.exports = __webpack_public_path__ + "img/mainGazit.210aa400.png";